import React from 'react';
import PropTypes from 'prop-types';
import { Card } from 'react-bootstrap';

const Globals = require('../../../../app/globals');
const StringUtil = require('../../../../app/shared/StringUtil');
import JsonTextArea from '../common/JsonTextArea';

const propTypes = {
    sendScoreError: PropTypes.shape({
        user_attempt_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        attempt: PropTypes.number,
        attempt_id: PropTypes.string,
        assignment_hash: PropTypes.string,
        nova_act_inst_id: PropTypes.string,
        score: PropTypes.number,
        time_played: PropTypes.number,
        status_date: PropTypes.string,
        status_token: PropTypes.string,
        user_third_party_email: PropTypes.string,
        user_third_party_id: PropTypes.string,
        user_partner_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        error_message: PropTypes.string,
        user_id: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
        resend_success: PropTypes.bool,
        lis_outcome_service_url: PropTypes.string,
        custom_openapi_base_url: PropTypes.string,
        custom_muzzy_api_gateway_url: PropTypes.string,
        integration_type: PropTypes.oneOfType([
            PropTypes.object, // possible null
            PropTypes.oneOf([
                Globals.integration_type.LTI,
                Globals.integration_type.CONNECT,
                Globals.integration_type.LOCAL,
                Globals.integration_type.GOOGLE_CLASSROOM,
            ]).isRequired
        ])
    }).isRequired
};

const defaultProps = {
};

function SendScoreErrorBlock(props) {
    const {
        user_id,
        user_third_party_id,
        user_third_party_email,
        user_partner_id,
        assignment_id,
        assignment_third_party_id,
        assignment_third_party_section_id,
        assignment_third_party_course_id,
        user_attempt_id,
        attempt,
        attempt_id,
        assignment_hash,
        nova_act_inst_id,
        score,
        time_played,
        status_date,
        status_token,
        resend_success,
        integration_type,
        error_message,
        lis_outcome_service_url,
        custom_openapi_base_url,
        custom_muzzy_api_gateway_url,
    } = props.sendScoreError;

    return (
        <Card body bg="light">
            <h2 className="heading-lg">User</h2>
            <ul className="margin-bottom-lg">
                <li><strong className="font-weight-bold">ID:</strong> {user_id}</li>
                <li><strong className="font-weight-bold">Third-Party ID:</strong> {user_third_party_id}</li>
                <li><strong className="font-weight-bold">Third-Party email:</strong> {user_third_party_email}</li>
                <li><strong className="font-weight-bold">Partner ID:</strong> {user_partner_id}</li>
            </ul>
            <h2 className="heading-lg">Assignment</h2>
            <ul className="margin-bottom-lg">
            <li><strong className="font-weight-bold">ID:</strong> {assignment_id}</li>
                <li><strong className="font-weight-bold">Hash:</strong> {assignment_hash}</li>
                <li><strong className="font-weight-bold">Third Party ID:</strong> {assignment_third_party_id}</li>
                <li><strong className="font-weight-bold">Third Party Section ID:</strong> {assignment_third_party_section_id}</li>
                <li><strong className="font-weight-bold">Third Party Course ID:</strong> {assignment_third_party_course_id}</li>
            </ul>
            <h2 className="heading-lg">Outcomes</h2>
            <ul className="margin-bottom-lg">
                <li><strong className="font-weight-bold">Integration Type:</strong> {integration_type}</li>
                {(integration_type === Globals.integration_type.CONNECT) &&
                    <li><strong className="font-weight-bold">Endpoint base URL:</strong> {custom_muzzy_api_gateway_url || custom_openapi_base_url}</li>
                }
                {(integration_type === Globals.integration_type.LTI) &&
                    <li><strong className="font-weight-bold">Endpoint URL:</strong> {lis_outcome_service_url}</li>
                }
                {(
                    integration_type === Globals.integration_type.LOCAL
                    || integration_type === Globals.integration_type.GOOGLE_CLASSROOM
                 ) &&
                    <li><em className="font-style-italic">Not available for this assignment type</em></li>
                }
            </ul>
            <h2 className="heading-lg">Attempt</h2>
            <ul className="margin-bottom-lg">
                <li><strong className="font-weight-bold">Attempt ID:</strong> {attempt_id}</li>
                <li><strong className="font-weight-bold">Attempt Nova Act Inst ID:</strong> {nova_act_inst_id}</li>
                <li><strong className="font-weight-bold">Attempt #:</strong> {attempt}</li>
            </ul>
            <h2 className="heading-lg">User-To-Attempt</h2>
            <ul className="margin-bottom-lg">
                <li><strong className="font-weight-bold">U2A ID:</strong> {user_attempt_id}</li>
                <li><strong className="font-weight-bold">Score:</strong> {score}</li>
                <li><strong className="font-weight-bold">Time Played:</strong> {StringUtil.getTimeStringForMs(time_played)}</li>
                <li><strong className="font-weight-bold">U2A Status Token:</strong> {status_token}</li>
                <li><strong className="font-weight-bold">U2A Status Date:</strong> {status_date}</li>
                <li><strong className="font-weight-bold">Error Message:</strong>
                    {!!error_message ?
                        <div>
                            <code className="codeBlock break-word">{error_message}</code>
                        </div>
                        :
                        <em className="font-style-italic"> None available</em>
                    }
                </li>
            </ul>
        </Card>
    );
}

SendScoreErrorBlock.propTypes = propTypes;
SendScoreErrorBlock.defaultProps = defaultProps;

export default SendScoreErrorBlock;